__turbopack_context__.v({
  "loadingWrapper": "CustomLoading-module-scss-module__y_a8Cq__loadingWrapper",
  "loadingWrapper_loading": "CustomLoading-module-scss-module__y_a8Cq__loadingWrapper_loading",
  "rotate": "CustomLoading-module-scss-module__y_a8Cq__rotate",
});
